import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const CircleDotsVertical: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12Z'
        stroke='black'
        strokeWidth='2'
      />
      <path
        d='M12.5001 12.5004V11.5H11.4998V12.5004H12.5001Z'
        stroke={fill}
        strokeWidth='2'
      />
      <path
        d='M12.5001 17.5004V16.5H11.4998V17.5004H12.5001Z'
        stroke={fill}
        strokeWidth='2'
      />
      <path
        d='M12.5001 7.50037V6.5H11.4998V7.50037H12.5001Z'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default CircleDotsVertical
